export const getUserOverviewData = () => {
  const getUserQuery = `query getUser ($where: UserWhereUniqueInput!) {
                          getUser (where: $where) {
                            hnId
                            UserMedicalDemograhicData {
                              gender
                              birthdate
                              province
                              district
                              allergic
                              userUnderlyingDiseaseTrasaction {
                                underlyingDisease {
                                  thaiName
                                  engName
                                }
                              }
                            }
                          }
                        }`

  return {
    query: getUserQuery,
    variables: {
      where: {
        uId: '',
      },
    },
  }
}

export const getDiseaseData = () => {
  const getDisease = `query getDiseases($where: DiseaseWhereInput! $orderBy: [DiseaseOrderByWithRelationInput!]){
    getDiseases(where: $where, orderBy: $orderBy) {
      dId
      thaiName
      medName
    }
  }`

  return {
    query: getDisease,
    variables: {
      where: {
        showFlag: {
          equals: true,
        },
      },
      orderBy: [
        {
          createdAt: 'asc',
        },
      ],
    },
  }
}

export const getOneDiseaseData = (medName: string) => {
  const query = `
    query getDiseases($where: DiseaseWhereInput){
      getDiseases(where: $where) {
        dId
        engName
        thaiName
        medName
        imagePath
        diseaseAttibute {
            daId
            type
            engName
            thaiName
            unitThai
            medName
            description
            condition
            inputFlag
            calFlag
            showFlag
            mandatoryFlag
        }
        associateDiease {
            adId
            thaiName
            imagePath
            associateDieaseAttibute {
                adaId
                medName
                thaiName
                unitThai
                description
                type
                indexSelect
                condition
                showFlag
                showPrevoius
            }
        }
        type
      }
    }
  `

  return {
    query: query,
    variables: {
      where: {
        medName: {
          equals: medName,
        },
      },
    },
  }
}

export const getDiseasesAttibutes = (disease_dId: string) => {
  const getDisease = `query getDiseasesAttibutes($where: DiseaseAttibuteWhereInput!){
    getDiseasesAttibutes(where: $where) {
      daId
      description
      thaiName
      medName
      unitThai
    }
  }`

  return {
    query: getDisease,
    variables: {
      where: {
        disease: {
          is: {
            medName: {
              equals: disease_dId,
            },
          },
        },
        showFlag: {
          equals: true,
        },
      },
      orderBy: [
        {
          createdAt: 'asc',
        },
      ],
    },
  }
}

export const getHealthStatusOverallDiseaseScorces = () => {
  const getHealthStatusOverallDiseaseScorces = `query getHealthStatusOverallDiseaseScorces($where: HealthStatusOverallScorceDataWhereInput! $orderBy: [HealthStatusOverallScorceDataOrderByWithRelationInput!], $take: Int){
    getHealthStatusOverallDiseaseScorces(where: $where, orderBy: $orderBy, take: $take) {
      value
      createdAt
    }
  }`

  return {
    query: getHealthStatusOverallDiseaseScorces,
    variables: {
      where: {
        puId: {
          equals: '',
        },
      },
      orderBy: [
        {
          createdAt: 'desc',
        },
      ],
      take: 1,
    },
  }
}

export const getHealthStatusDiseaseScorces = (disease_dId: string) => {
  const getHealthStatusDiseaseScorces = `query getHealthStatusDiseaseScorces($where: HealthStatusDiseaseScorceDataWhereInput! $orderBy: [HealthStatusDiseaseScorceDataOrderByWithRelationInput!], $take: Int){
    getHealthStatusDiseaseScorces(where: $where, orderBy: $orderBy, take: $take) {
      value
      createdAt
    }
  }`

  return {
    query: getHealthStatusDiseaseScorces,
    variables: {
      where: {
        puId: {
          equals: '',
        },
        disease: {
          is: {
            medName: {
              equals: disease_dId,
            },
          },
        },
      },
      orderBy: [
        {
          createdAt: 'desc',
        },
      ],
      take: 1,
    },
  }
}
export const getMedDataTransactionsForBmi = (daId: string) => {
  const getMedDataTransactions = `query getMedDataTransactions($where: UserMedTrasactionWhereInput, $take: Int, $skip: Int, $orderBy: [UserMedTrasactionOrderByWithRelationInput!]){
    getMedDataTransactions(where: $where, take: $take, skip: $skip, orderBy: $orderBy) {
      value
      createdAt
    }
  }`

  return {
    query: getMedDataTransactions,
    variables: {
      where: {
        userMedicalData: {
          is: {
            puId: {
              equals: '',
            },
          },
        },
        daId: {
          equals: daId,
        },
        diseaseAttibute: {
          is: {
            showFlag: {
              equals: true,
            },
          },
        },
      },
      orderBy: [
        {
          createdAt: 'desc',
        },
      ],
      take: 6,
    },
  }
}

export const getMedDataTransactionsBydId = (daId: string) => {
  const getMedDataTransactions = `query getMedDataTransactions($where: UserMedTrasactionWhereInput! $orderBy: [UserMedTrasactionOrderByWithRelationInput!], $take: Int){
    getMedDataTransactions(where: $where, orderBy: $orderBy, take: $take) {
      value
      createdAt
    }
  }`

  return {
    query: getMedDataTransactions,
    variables: {
      where: {
        userMedicalData: {
          is: {
            puId: {
              equals: '',
            },
          },
        },
        daId: {
          equals: daId,
        },
        diseaseAttibute: {
          is: {
            showFlag: {
              equals: true,
            },
          },
        },
      },
      orderBy: [
        {
          createdAt: 'desc',
        },
      ],
      take: 6,
    },
  }
}

export const getMedDataTransactionsByadaId = (adaId: string) => {
  const getMedDataTransactions = `query getMedDataTransactions($where: UserMedTrasactionWhereInput! $orderBy: [UserMedTrasactionOrderByWithRelationInput!], $take: Int){
    getMedDataTransactions(where: $where, orderBy: $orderBy, take: $take) {
      value
      createdAt
    }
  }`

  return {
    query: getMedDataTransactions,
    variables: {
      where: {
        userMedicalData: {
          is: {
            puId: {
              equals: '',
            },
          },
        },
        adaId: {
          equals: adaId,
        },
        associateDieaseAttibute: {
          is: {
            showFlag: {
              equals: true,
            },
          },
        },
      },
      orderBy: [
        {
          createdAt: 'desc',
        },
      ],
      take: 6,
    },
  }
}

export const getLatestMedDataTransactionByadaID = (adaId: string) => {
  const getMedDataTransactions = `query getMedDataTransactions($where: UserMedTrasactionWhereInput! $orderBy: [UserMedTrasactionOrderByWithRelationInput!], $take: Int){
    getMedDataTransactions(where: $where, orderBy: $orderBy, take: $take) {
      value
      createdAt
    }
  }`

  return {
    query: getMedDataTransactions,
    variables: {
      where: {
        userMedicalData: {
          is: {
            puId: {
              equals: '',
            },
          },
        },
        adaId: {
          equals: adaId,
        },
        associateDieaseAttibute: {
          is: {
            showFlag: {
              equals: true,
            },
          },
        },
      },
      orderBy: [
        {
          createdAt: 'desc',
        },
      ],
      take: 1,
    },
  }
}

export const getAssociateMedDataTransactions = (adaId: string) => {
  const query = `
    query getMedDataTransactions($where: UserMedTrasactionWhereInput! $orderBy: [UserMedTrasactionOrderByWithRelationInput!], $take: Int){
      getMedDataTransactions(where: $where, orderBy: $orderBy, take: $take) {
        value
        createdAt
      }
    }
  `

  return {
    query: query,
    variables: {
      where: {
        userMedicalData: {
          is: {
            puId: {
              equals: '',
            },
          },
        },
        adaId: {
          equals: adaId,
        },
        associateDieaseAttibute: {
          is: {
            showFlag: {
              equals: true,
            },
          },
        },
      },
      orderBy: [
        {
          createdAt: 'desc',
        },
      ],
      take: 6,
    },
  }
}

export const getDiseaseAttibutesCondition = (daId: string) => {
  const querySchema = `query getDiseaseAttibuteCondition($where: DiseaseAttibuteWhereInput) {
                        getDiseaseAttibuteCondition(where: $where) {
                          daId
                          condition
                        }
                      }`

  return {
    query: querySchema,
    variables: {
      where: {
        daId: {
          equals: daId,
        },
      },
    },
  }
}

export const getAssociateDiseaseAttibuteCondition = (adaId: string) => {
  const querySchema = `query getAssociateDiseaseAttibuteCondition($where: AssociateDieaseAttibuteWhereInput) {
    getAssociateDiseaseAttibuteCondition(where: $where) {
      adaId
      condition
    }
  }`

  return {
    query: querySchema,
    variables: {
      where: {
        adaId: {
          equals: adaId,
        },
      },
    },
  }
}

export const getConsultType = () => {
  const getConsultType = `query getConsultType {
    getConsultType  {
        ctId
        typeName
    }
}`

  return {
    query: getConsultType,
    variables: {
      where: {
        showFlag: {
          equals: true,
        },
      },
    },
  }
}

export const getDiagnoseLastOne = (uId: string) => {
  const getDiagnoseLastOne = `
    query getDiagnoseLastOne ($where: DiagnoseWhereInput, $orderBy: [DiagnoseOrderByWithRelationInput!]) {
      getDiagnoseLastOne (where: $where, orderBy: $orderBy) {
          icdData
          allergy
          detail
          recommend
          drugData
          costTotal
          incomeTotal
          uId
          duId
          createdAt
      }
  }
  `

  return {
    query: getDiagnoseLastOne,
    variables: {
      where: {
        uId: {
          equals: uId,
        },
      },
      orderBy: [
        {
          createdAt: 'desc',
        },
      ],
    },
  }
}

export const getConsultOne = (uId: string) => {
  const getConsultOne = `
  query getConsultOne ($where: ConsultWhereInput, $orderBy: [ConsultOrderByWithRelationInput!]) {
    getConsultOne (where: $where, orderBy: $orderBy) {
        cId
        placeName
        time
        ctId
        textConsult
        uid
        createdAt
        dateConsult
        finishedFlag
        temp
        bp_sys
        bp_dia
        hr
        rr
    }
}
  `

  return {
    query: getConsultOne,
    variables: {
      where: {
        uid: {
          equals: uId,
        },
        isDiagnose: {
          equals: false,
        },
      },
      orderBy: [
        {
          createdAt: 'desc',
        },
      ],
    },
  }
}
